<script lang="ts">
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct"

  import Text from "../../Common/Text.svelte"

  export let product: RecommendedProduct
</script>

<Text class="product-vendor">
  {product.vendor || ""}
</Text>
